<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <!-- <div class="col-12">
        <navbar
          isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
        />
      </div> -->
    </div>
  </div>

  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Sign In</h4>
                  <p class="mb-0">Enter your email and password to sign in</p>
                </div>
                <div class="card-body">
                  <form role="form">
                    <div class="mb-3">
                      <argon-input type="email" id="email" placeholder="Email" name="email" size="lg" />
                    </div>
                    <div class="mb-3">
                      <argon-input type="password" id="password" placeholder="Password" name="password" size="lg" />
                    </div>
                    <!-- <argon-switch id="rememberMe">Remember me</argon-switch> -->
                    <argon-button @click="login()" class="mt-2" variant="gradient" color="success" fullWidth size="lg">Sign in</argon-button>
                  </form>
                </div>
                <!-- <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    Superuser?
                    <a href="/super" class="text-success text-gradient font-weight-bold">Click here</a>
                  </p>
                </div> -->
              </div>
            </div>
            <div class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column">
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style="background-image: url('https://img.freepik.com/premium-photo/young-asian-bride-groom-posing-pink-background_296537-4490.jpg?w=1060'); background-size: cover; background-position: center"
              >
                <span class="mask bg-gradient-dark opacity-4"></span>
                <h4 class="mt-5 text-white font-weight-bolder position-relative">Effortless Event Manager</h4>
                <p class="text-white position-relative">The more effortless the writing looks, the more effort the writer actually put into the process.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
  // import Navbar from "@/examples/PageLayout/Navbar.vue";
  import ArgonInput from "@/components/ArgonInput.vue";
  // import ArgonSwitch from "@/components/ArgonSwitch.vue";
  import ArgonButton from "@/components/ArgonButton.vue";
  import axios from "axios";
  import $ from "jquery";
  const body = document.getElementsByTagName("body")[0];
  import sha256 from "crypto-js/sha256";

  export default {
    name: "signin",
    components: {
      // Navbar,
      ArgonInput,
      // ArgonSwitch,
      ArgonButton,
    },
    created() {
      this.$store.state.hideConfigButton = true;
      this.$store.state.showNavbar = false;
      this.$store.state.showSidenav = false;
      this.$store.state.showFooter = false;
      body.classList.remove("bg-gray-100");
      if (this.getLogged()) {
        this.$router.push({ name: "Dashboard", query: { redirect: "/dashboard" } });
      }
    },

    beforeUnmount() {
      this.$store.state.hideConfigButton = false;
      this.$store.state.showNavbar = true;
      this.$store.state.showSidenav = true;
      this.$store.state.showFooter = true;
      body.classList.add("bg-gray-100");
    },
    methods: {
      getLogged() {
        return this.$store.state.user.keeplogged;
      },
      login() {
        event.preventDefault();
        const credential = {
          email: $("#email").val(),
          password: $("#password").val(),
        };

        axios
          .post("https://api.macra.co.id/mavent/admin/login", credential)
          .then((response) => {
            this.$store.state.user = response.data.dataLogin;
            this.$store.state.user.keeplogged = true;
            localStorage.setItem("token", response.data.token);
            console.log(this.$store.state.user);
            if (this.getLogged()) {
              this.$router.push({ name: "Dashboard", query: { redirect: "/dashboard" } });
            }
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
          });
      },
    },
  };
</script>
